'use client';

import { motion } from 'framer-motion';
import { ArrowLeft } from 'lucide-react';
import { useTranslations } from 'next-intl';

import { Link } from '@/i18n/routing';

export function NotFoundContent() {
  const t = useTranslations('NotFound');

  return (
    <main className="font-matter bg-section-b relative flex min-h-screen w-full flex-col items-center justify-center overflow-hidden px-4">
      {/* Subtle Noise Texture */}
      <div
        className="pointer-events-none absolute inset-[-10px_-40px] opacity-[0.08] mix-blend-plus-lighter"
        style={{
          backgroundImage: 'url("/landing/noise.png")',
          width: '1520px',
          height: '100%',
          backgroundRepeat: 'repeat',
        }}
      />

      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="relative z-10 flex flex-col items-center gap-[24px] text-center"
      >
        <h1 className="font-matter text-text-primary text-[60px] leading-[64px] font-semibold tracking-[-0.035em] md:text-[92px] md:leading-[90px]">
          Lost your way? <br />
          <span className="text-[#13B8A5]">Let&apos;s go back.</span>
        </h1>

        <p className="font-matter text-text-secondary max-w-[540px] text-[18px] leading-[28px] font-normal md:text-[20px] md:leading-[32px]">
          {t('description')}
        </p>

        <div className="mt-[20px]">
          <Link
            href="/"
            className="flex h-[51px] w-[202px] cursor-pointer items-center justify-center gap-2 rounded-full bg-[radial-gradient(74.03%_95.19%_at_48.09%_47.12%,#14CCB7_0%,#13B8A5_100%)] text-[16px] font-medium text-white shadow-[0px_2px_4px_rgba(19,184,165,0.3),inset_0px_3px_3px_rgba(255,255,255,0.2)] transition-all hover:opacity-95"
          >
            <ArrowLeft size={18} /> {t('backToHome')}
          </Link>
        </div>
      </motion.div>

      {/* Background radial gradient abstract */}
      <div className="pointer-events-none absolute top-1/2 left-1/2 h-[800px] w-[800px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[radial-gradient(circle_at_center,rgba(19,184,165,0.05)_0%,transparent_60%)] mix-blend-multiply blur-3xl" />
    </main>
  );
}
